import PropTypes from 'prop-types';
import React from 'react';

import useConfig from 'common/hooks/useConfig';

import { PREMIUM_PRODUCT_KEYS } from './constants';
import HubspotEmbed from './HubspotEmbed';

// PremiumRoute is a v6 feature-flag gate. The caller is responsible for
// wrapping its sub-routes in a <Routes> element. When the product is enabled,
// children render unchanged; when disabled, the HubspotEmbed upgrade prompt
// shows in their place.
const PremiumRoute = ({ productKey, children }) => {
  const config = useConfig();
  const isProductEnabled = config.isConfigEnabled(productKey);

  if (!isProductEnabled) {
    return <HubspotEmbed productKey={productKey} />;
  }

  return children;
};

PremiumRoute.propTypes = {
  productKey: PropTypes.oneOf(Object.values(PREMIUM_PRODUCT_KEYS)).isRequired,
  children: PropTypes.node.isRequired,
};

export default PremiumRoute;
